import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Força o scroll para o topo imediatamente
    window.scrollTo(0, 0);
    
    // Também tenta com um pequeno delay para garantir que funcione
    // mesmo se houver animações ou carregamento assíncrono
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }, 100);

    return () => clearTimeout(timer);
  }, [pathname]);

  // Adiciona listener para cliques em links como fallback
  useEffect(() => {
    const handleLinkClick = (e) => {
      // Verifica se é um link interno
      const link = e.target.closest('a[href^="/"]');
      if (link) {
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        }, 50);
      }
    };

    document.addEventListener('click', handleLinkClick);
    return () => document.removeEventListener('click', handleLinkClick);
  }, []);

  return null; // Este componente não renderiza nada
};

export default ScrollToTop; 